import { useRef } from "react";
import { useGameStateListeners } from "./useGameStateListeners";
import { useGameTradeListeners } from "./useGameTradeListeners";
import { useGameEventListeners } from "./useGameEventListeners";
import { useGameActionListeners } from "./useGameActionListeners";
import { useGameConnectionListeners } from "./useGameConnectionListeners";

export const useGameSocketListeners = (
  socket,
  name,
  room,
  setLoggedIn,
  roundNumber = 1,
  {
    setStocks,
    setIndexes,
    setActiveEvents,
    setNewEventIds,
    setVisualEffects,
    setGameLog,
    setCurrentTurn,
    setCurrentPhase,
    setMaxRounds,
    setMaxActionsPerTurn,
    setMaxActionCards,
    setPlayerCash,
    setPlayerNetWorths,
    setPlayerPortfolios,
    setPlayerIndexPortfolios,
    setActionsRemaining,
    setMaxActionsThisTurn,
    setStockOwnershipCounts,
    setStockOwnershipByPlayer,
    setIndexOwnershipByPlayer,
    setPlayerColors,
    setPlayerEmojis,
    setPlayerActionCards,
    setNewActionCardIds,
    setMyTurn,
    setPlayers,
    setUpdates,
    setHasJoinedGame,
    showMessage,
    addNotification,
    processGameLogUpdate,
    initializeFromGameLog,
    clearAllNotifications,
    hasJoinedGameRef,
    roomRef,
    nameRef,
    notificationRefs,
    dismissingRef,
    setSelectedActionCard,
    setActionMode,
    playerColorsRef,
    playerEmojisRef
  }
) => {
  const firstTurnRef = useRef(true);

  useGameStateListeners(socket, name, roundNumber, {
    setPlayers,
    setPlayerColors,
    setPlayerEmojis,
    setPlayerActionCards,
    setMaxRounds,
    setMaxActionsPerTurn,
    setMaxActionCards,
    setCurrentPhase,
    setGameLog,
    setCurrentTurn,
    setMyTurn,
    setPlayerCash,
    setUpdates,
    setHasJoinedGame,
    hasJoinedGameRef,
    showMessage,
    addNotification,
    clearAllNotifications,
    notificationRefs,
    dismissingRef,
    initializeFromGameLog,
    firstTurnRef
  });

  useGameTradeListeners(socket, {
    setPlayerPortfolios,
    setPlayerIndexPortfolios,
    setActionsRemaining,
    setMaxActionsThisTurn,
    setStockOwnershipCounts,
    setStockOwnershipByPlayer,
    setIndexOwnershipByPlayer,
    setPlayerNetWorths,
    showMessage,
    addNotification,
    setLoggedIn
  });

  useGameEventListeners(socket, {
    setStocks,
    setIndexes,
    setActiveEvents,
    setNewEventIds,
    setVisualEffects,
    setStockOwnershipCounts,
    setStockOwnershipByPlayer,
    setIndexOwnershipByPlayer,
    setGameLog,
    processGameLogUpdate,
    showMessage
  });

  useGameActionListeners(socket, name, {
    setPlayerActionCards,
    setNewActionCardIds,
    setSelectedActionCard,
    setActionMode,
    showMessage,
    addNotification,
    setLoggedIn
  });

  useGameConnectionListeners(socket, {
    hasJoinedGameRef,
    nameRef,
    roomRef,
    showMessage,
    setLoggedIn,
    clearAllNotifications,
    notificationRefs,
    dismissingRef,
    setGameLog,
    setCurrentPhase,
    setStocks,
    setIndexes,
    setActiveEvents,
    setVisualEffects,
    setCurrentTurn,
    setPlayerCash,
    setPlayerNetWorths,
    setPlayerPortfolios,
    setPlayerIndexPortfolios,
    setActionsRemaining,
    setMaxActionsThisTurn,
    setStockOwnershipCounts,
    setStockOwnershipByPlayer,
    setIndexOwnershipByPlayer,
    setPlayerActionCards,
    setNewActionCardIds,
    setNewEventIds,
    setMyTurn,
    playerColorsRef,
    playerEmojisRef
  });
};
